<!--
 * @Description: 这是一个弹窗
 * @Date: 2021-03-22 09:49:46
 * @LastEditTime: 2021-03-22 18:27:32
-->
<template>
  <!-- 元素插入body -->
  <!-- <teleport to="body"> -->
  <div class="popup-cont">
    <transition name="fade">
      <div class="popup-mask" v-if="visible" @click.stop="hide"></div>
    </transition>
    <transition :name="position">
      <div class="popup-main" :class="`popup--${position}`" v-if="visible">
        <slot></slot>
      </div>
    </transition>
  </div>
  <!-- </teleport> -->
</template>

<script>
export default {
  name: "gac-popup",
  props: {
    // modelValue: {
    //   type: Boolean,
    //   default: false
    // },
    value: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "center",
    },
  },
  computed: {
    visible() {
      // return this.modelValue;
      return this.value;
    },
  },
  // watch: {
  //   modelValue(val) {
  //     if (val) {
  //       this.$emit("show");
  //     } else {
  //       this.$emit("close");
  //     }
  //   }
  // },
  // emits: ["update:modelValue"],
  methods: {
    hide() {
      let value = false;
      // this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base/variables";
.popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup-main {
  position: fixed;
  z-index: 100;
}
.popup--bottom {
  bottom: 0;
  left: 0;
  width: 100%;
}
.popup--center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

// transform居中导致文字滚动模糊，加个flex版本
.popup--flexcenter {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms $easeOutCubic;
}
.fade-enter,
.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}

.center-enter-active,
.center-leave-active {
  transition: transform 200ms $easeOutCubic, opacity 200ms $easeOutCubic;
}

.center-enter,
.center-enter-from,
.center-leave-to {
  transform: translate(-50%, -50%) scale(0.6) !important;
  opacity: 0 !important;
}

.bottom-enter-active,
.bottom-leave-active {
  transition: transform 200ms $easeOutCubic;
}

.bottom-enter,
.bottom-enter-from,
.bottom-leave-to {
  transform: translateY(100%);
}

.flexcenter-enter-active,
.flexcenter-leave-active {
  transition: transform 200ms $easeOutCubic, opacity 200ms $easeOutCubic;
}

.flexcenter-enter,
.flexcenter-enter-from,
.flexcenter-leave-to {
  transform: scale(0.6) !important;
  opacity: 0 !important;
}
</style>
